export default __webpack_public_path__ + "static/media/hedef-500bin_5_copy_2-04.8fa0677f.svg";